import api from '../../services/api';

const state = {
  customers: [],
  currentCustomer: null,
  loading: false,
  error: null,
};

const getters = {
  allCustomers: s => s.customers,
  currentCustomer: s => s.currentCustomer,
  isLoading: s => s.loading,
};

const actions = {
  async fetchCustomers({ commit }) {
    commit('SET_LOADING', true);
    try {
      const res = await api.get('/customers');
      commit('SET_CUSTOMERS', res.data);
      return { success: true };
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.error || 'Failed to fetch customers');
      return { success: false };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchCustomer({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      const res = await api.get(`/customers/${id}`);
      commit('SET_CURRENT_CUSTOMER', res.data);
      return { success: true, data: res.data };
    } catch (err) {
      commit('SET_ERROR', err.response?.data?.error || 'Failed to fetch customer');
      return { success: false };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async createCustomer({ dispatch }, data) {
    try {
      const res = await api.post('/customers', data);
      await dispatch('fetchCustomers');
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to create' };
    }
  },

  async updateCustomer({ dispatch }, { id, data }) {
    try {
      const res = await api.put(`/customers/${id}`, data);
      await dispatch('fetchCustomers');
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to update' };
    }
  },

  async deleteCustomer({ dispatch }, id) {
    try {
      await api.delete(`/customers/${id}`);
      await dispatch('fetchCustomers');
      return { success: true };
    } catch (err) {
      return {
        success: false,
        error: err.response?.data?.message || err.response?.data?.error || 'Failed to delete',
      };
    }
  },
};

const mutations = {
  SET_CUSTOMERS(s, v) { s.customers = v; },
  SET_CURRENT_CUSTOMER(s, v) { s.currentCustomer = v; },
  SET_LOADING(s, v) { s.loading = v; },
  SET_ERROR(s, v) { s.error = v; },
};

export default { namespaced: true, state, getters, actions, mutations };
